import React from 'react';
//import fs from 'fs';
import {
  Markup
} from "../components";

import {
  Header,
  Footer
} from '../containers';

/**
 * 联系我们
 */
export default class Contact extends React.Component {
  constructor(props){
    document.title = "联系我们"
    super(props)
    this.state = {
      text: 'Loading...'
    }
  }

  render() {
    const contact = 
      `### 郑州立行信息技术有限公司`
      + "\n" +
      `
      地址：郑州市南阳路192号.
      固定电话：0371-63285443
      技术支持：18039105900
      `;
    return (
      <div>
        <Header/>
        <div className="container">
          <Markup>
            {contact}
          </Markup>
        </div>
        <Footer/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/Contact.js